// Import modules
import mobileMenu from './modules/mobile-menu.js';
import modal from './modules/modal.js';
import notification from './modules/notification.js';
import Swiper from 'swiper/bundle';
import { Fancybox } from '@fancyapps/ui';
import Sticky from './modules/sticky.js';
import stickyHeader from './modules/sticky-header.js';
import adIframes from './modules/ad-iframes.js';

// Init functions
let initialized = false;

function init() {
	// Cookiebot (auto-blocking) calls window.onload() again after it releases blocked scripts, and
	// a second run binds every listener twice: the hamburger then opens and closes in one click.
	if (initialized) return;
	initialized = true;

	// init fancybox
	Fancybox.bind('[data-fancybox]');

	// init mobile menu --> wp-content/themes/expl-theme/source/scripts/modules/mobile-menu.js
	mobileMenu();

	// init sticky header compact state --> wp-content/themes/expl-theme/source/scripts/modules/sticky-header.js
	stickyHeader();

	// init HTML5 ad iframes scaled to their block --> wp-content/themes/expl-theme/source/scripts/modules/ad-iframes.js
	adIframes();

	// init modal --> wp-content/themes/expl-theme/source/scripts/modules/modal.js
	modal();


	// init notification --> wp-content/themes/expl-theme/source/scripts/modules/notification.js
	// init notification popup
	document.querySelector('.notification-popup') &&
		notification('.notification-popup', 'notification-popup', 1000);

	// init notification snackbar
	document.querySelector('.notification-snackbar') &&
		notification('.notification-snackbar', 'notification-snackbar', 2000);


	var NewsSwiperHome = new Swiper(".NewsSwiperHome", {
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		keyboard: true,
		autoplay: {
			delay: 5000,
			disableOnInteraction: true
		},
		pagination: {
			el: ".swiper-pagination",
			type: "progressbar",
		},
	});

	var ArticleImgSlider = new Swiper(".article-img-slider", {
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		keyboard: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: true
		},
	});

	var sticky = new Sticky('.sidebar-inner');

}

// Run the init function when the page loads (a listener, not window.onload, so Cookiebot cannot replay it)
window.addEventListener('load', init);
